import axios from 'axios'

import { reatailmediaApi as baseAPI } from '../api'

const baseURL = `${baseAPI}/billing-ops/insertion-orders`

export const listInsertionOrdersKey = 'listInsertionOrders'

export const listInsertionOrdersService = (
  params?: ListInsertionOrdersParams
) => axios.get<ListInsertionOrdersResponse>(baseURL, { params })
